import { observable, action, computed } from 'mobx';

class SearchBarStore {
  @observable suggestionSelected = false;

  @observable savedSearch = [];

  MAX_RECENT_SEARCHES = 5;

  MAX_CHAR_LOCAL_STORAGE = 100;

  LOCAL_STORAGE_KEY = 'recentSearches';

  @action saveSearchQuery(rawQuery) {
    if (!rawQuery || typeof rawQuery !== 'string') return;

    rawQuery = rawQuery.slice(0, this.MAX_CHAR_LOCAL_STORAGE);

    if (rawQuery === '') return;

    let recentSearches = this.getSavedSearchQuery();

    // Remove duplicates (case-insensitive)
    recentSearches = recentSearches.filter(
      (item) => item.toLowerCase() !== rawQuery.toLowerCase(),
    );

    recentSearches.unshift(rawQuery);
    recentSearches = recentSearches.slice(0, this.MAX_RECENT_SEARCHES);

    localStorage.setItem(
      this.LOCAL_STORAGE_KEY,
      JSON.stringify(recentSearches),
    );
    this.savedSearch =
      JSON.parse(localStorage.getItem(this.LOCAL_STORAGE_KEY)) || [];
  }

  @action getSavedSearchQuery() {
    this.savedSearch =
      JSON.parse(localStorage.getItem(this.LOCAL_STORAGE_KEY)) || [];
    return this.savedSearch;
  }
}

export default SearchBarStore;
